import React from 'react';

const Footer = () => {


  return (
    <div className="absolute w-full bottom-0 p-4 bg-custom-darkPurple lg:pin-b lg:mt-16 text-center text-custom-orange">
      {/* <footer>
        Created by Tyler Arthur
      </footer> */}
    </div>
  );
}

export default Footer;